import { createApp } from 'vue'
import App from './App.vue'
import mask from './directives/mask';
import router from './router/index';

const app = createApp(App);

app.use(router);
app.directive('mask', mask);
app.mount('#app');